module.exports = __webpack_public_path__ + "img/数字孪生dark.07acd917.png";